import store from '@/store';
import { getSistemaSelecionado } from '@/util';
import { rotasComuns } from './routesComuns';
import { rotasSautec } from './routesSautec';
import { rotasFinanceiro } from './routesFinanceiro';
import { rotasAdministrativo } from './routesAdministrativo';
import { rotasSuporte } from './routesSuporte';

export const getRotas = async () => {
    let todasAsRotas = rotasComuns;
    const cdsistema = getSistemaSelecionado();
    if (!cdsistema) {
        return todasAsRotas;
    }
    //console.log('getRotas cdsistema selecionado:', cdsistema);
    let rotasDoSistema = [];
    if (cdsistema == 1) {
        rotasDoSistema = rotasSautec;
    } else if (cdsistema == 2) {
        rotasDoSistema = rotasFinanceiro;
    } else if (cdsistema == 3) {
        rotasDoSistema = rotasAdministrativo;
    } else if (cdsistema == 4) {
        rotasDoSistema = rotasSuporte;
    }
    //console.log('getRotas rotasSuporte:', rotasSuporte);
    let userAuthorities = [];
    if (store.state.usuario) {
        userAuthorities = store.state.usuario.authorities.map(auth => auth.authority);
    }
    rotasDoSistema.forEach((item) => {
        const requerGrants = item.meta.grants && item.meta.grants.length > 0;
        const hasPermission = !requerGrants || item.meta.grants.some(grant => userAuthorities.includes(grant));        
        //console.log('getRotas item:', item, 'hasPermission:', hasPermission);
        if (hasPermission) {
            let target = null;
            if (item.meta.abrirDentroDoLayout) {
                target = todasAsRotas[0].children;
            } else {
                target = todasAsRotas;
            }
            target.push(item);
        }
    });
    //console.log('todasAsRotas', todasAsRotas);
    return todasAsRotas;
};

export const updateDynamicRoutes = async (router) => {
    console.log('rotas Antes', router.getRoutes().length);
    router.getRoutes().forEach(route => {
        if (route.name) {
            try {
                router.removeRoute(route.name);
            } catch (e) {
                console.warn(`Não foi possível remover a rota: ${route.name}`);
            }
        }
    });
    const rotas = await getRotas();
    rotas.forEach(route => {
        router.addRoute(route);
    });
    return;
};